<template>
    <div class="info-all">
        <div class="info-box">
            <div><img src="../../../assets/images/user/popup/popup_top.png" /></div>
            <!-- 姓名 -->
            <div class="name-box">
                <div class="name-title">姓名：</div>
                <input class="name-input" v-model="name" placeholder="请输入姓名" />
            </div>
            <!-- 电话 -->
            <div class="name-box">
                <div class="name-title">电话：</div>
                <input class="name-input" v-model="phone" placeholder="请输入电话" />
            </div>
            <div class="address-title">地址:</div>
            <!-- 省市区 -->
            <div class="address-box">
                <div class="province">省</div>
                <div class="province">市</div>
                <div class="province">区</div>
            </div>
            <!-- 详细地址 -->
            <div class="address-detail">
                <input class="address-input" v-model="address" placeholder="请输入您的详细地址" />
            </div>
            <div class="category-box">
                <div class="category">品类</div>
                <div class="tips">（品类可多选）</div>
            </div>
            <div class="button-box">
                <div :class="item.state == 0?'cate-button':'cate-button-item'" v-for="(item,index) in arrCategory"
                    @click="changeCate(item)">
                    <div>{{item.title}}</div>
                </div>
            </div>
            <div class="signUp" @click="getPush">
                立即报名
            </div>
        </div>
    </div>
</template>

<script>
    import oPush from "@/js/user/info.js";
    import oForm from "@/js/form.js";
    export default {
        data() {
            return {
                arrCategory: [{
                        id: 1,
                        title: '热水器',
                        state: 0
                    },
                    {
                        id: 2,
                        title: '烟机',
                        state: 0
                    },
                    {
                        id: 3,
                        title: '净水机',
                        state: 0
                    },
                    {
                        id: 4,
                        title: '冷暖风水',
                        state: 0
                    },
                    {
                        id: 5,
                        title: '其它',
                        state: 0
                    },
                ],
                name: '',
                phone: '',
                province: '',
                city: '',
                district: '',
                address: '',
                type:[],
                arrProvince:[],//省
            }
        },
        created() {
            $init(() => {
                this.getTree();
                // this.getPush();
            });
        },
        methods: {
            //点击品类多选
            changeCate(item) {
                item.state=item.state?0:1
                let arrType =[]
                this.arrCategory.forEach(it=>{
                    if(it.state){
                        arrType.push(it.title)
                    }
                })
                this.type = arrType
            },
            // 获取地址三级联动数据
            getTree() {
                oForm.getTree().then((res) => {
                    console.log(res, '省市区res')
                    let arrTree = res.data.data.result;
                    let arrProvince = arrTree[0];
                    arrProvince.forEach((it) => {
                        it["value"] = it.name;
                        if (arrTree[it.id].length) {
                            it["children"] = arrTree[it.id];
                            it.children.forEach((sit) => {
                                sit["value"] = sit.name;
                                // sit['children'] = arrTree[sit.id]
                            });
                        }
                    });
                });
            },
            getPush() {
                oPush.freePush({
                    name: this.name,
                    phone: this.phone,
                    province: this.province,
                    city: this.city,
                    district: this.district,
                    address: this.address,
                    type: this.type,
                }).then((res) => {
                    console.log(res, 'push.res')
                })
            }
        }
    }
</script>

<style lang='scss' scoped>
    .info-all {
        width: 100%;
        height: 100vh;
        position: relative;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.6000);
        padding-top: 78px;

        .info-box {
            width: 592px;
            height: 1136px;
            margin: 0 auto;
            background: #FFFFFF;
            border-radius: 24px;
        }

        .name-box {
            width: 528px;
            height: 96px;
            background: #F5F5F5;
            border-radius: 16px;
            margin: 0 auto;
            display: flex;
            margin-top: 32px;
            line-height: 96px;

            .name-title {
                color: #A4A4A4;
                font-size: 28px;
                padding: 0px 32px;
            }

            .name-input {
                text-align: center;
                background: #F5F5F5;
            }

        }

        .address-title {
            padding: 40px 32px 20px 32px;
            color: #161616;
            font-size: 28px;
        }

        .address-box {
            padding: 0 32px;
            display: flex;
            margin-bottom: 20px;
            justify-content: space-between;

            .province {
                width: 160px;
                height: 96px;
                background: #F5F5F5;
                border-radius: 16px;
                line-height: 96px;
                text-align: center;
                color: #A4A4A4;
                font-size: 28px;
            }
        }

        .address-detail {
            width: 528px;
            height: 96px;
            background: #F5F5F5;
            border-radius: 16px;
            padding: 0 32px;
            margin: 0 auto;
            line-height: 96px;

            /* margin-top: 32px; */
            .address-input {
                background: #F5F5F5;
            }

        }

        .category-box {
            margin: 44px 32px 20px 32px;
            display: flex;

            .category {
                color: #161616;
                font-size: 28px;
            }

            .tips {
                color: #A6A6A6;
                font-size: 24px;
                line-height: 42px;
            }
        }

        .button-box {
            padding: 0 32px;
            display: flex;
            flex-wrap: wrap;

            .cate-button {
                width: 148px;
                height: 80px;
                background: #F5F5F5;
                border-radius: 16px;
                color: #A4A4A4;
                font-size: 28px;
                line-height: 80px;
                text-align: center;
                margin: 0 42px 28px 0;

                &:nth-child(3n) {
                    margin: 0;
                }
            }

            .cate-button-item {
                width: 148px;
                height: 80px;
                background: rgba(49, 133, 68, 0.1500);
                border-radius: 16px;
                color: #318544;
                font-size: 28px;
                line-height: 80px;
                text-align: center;
                margin: 0 42px 28px 0;

                &:nth-child(3n) {
                    margin: 0;
                }
            }
        }

        .signUp {
            width: 308px;
            height: 80px;
            background: #318544;
            box-shadow: 0px 4px 12px 0px rgba(49, 133, 68, 0.3500);
            border-radius: 12px;
            margin: 0 auto;
            line-height: 80px;
            text-align: center;
            font-size: 28px;
            color: #ffffff;
        }
    }
</style>
